import React from 'react';
import { Form } from 'fw/forms';
import { Button } from 'react-bootstrap'

class QuerySearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: Object.assign(this.initialForm(), this.props.filters)
        }
    }

    initialForm() { return {}; }
    ready() { return null; }

    handleSubmit = (e) => {
        e.preventDefault();
        this.search();
    }

    handleReset = (e) => {
        e.preventDefault();

        // Reset State
        this.setState({
            form: this.initialForm()
        }, function () {
            this.search();
        });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    search = () => {
        const me = this;

        this.props.onSearch(this.state.form, function () {
            me.ready();
        });
    }

    componentDidMount() {
        this.search();
    }

    render() {
        return (
            <Form
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
                onReset={this.handleReset}
                values={this.state.form}>
                {this.renderForm()}
                <div className="pull-right" style={{ marginTop: "-35px" }}>
                    <Button id="btnSearch" type="submit" bsStyle="primary" style={{ marginRight: 5, width: 70 }}>Search</Button>
                    <Button id="btnReset" type="reset" bsStyle="default" style={{ width: 70 }}>Reset</Button>
                </div>
                <hr style={{ marginTop: "5px" }} />

            </Form>
        )
    }
}

export default QuerySearch;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/query/QuerySearch.js